import React, { PropsWithChildren, useMemo } from "react";
import { CssBaseline } from "@mui/material";
import {
  createTheme,
  Theme,
  ThemeProvider as MUIThemeProvider,
} from "@mui/material/styles";
import { useThemeSettings } from "../hooks";
import { createThemeOptions } from "../config";

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const { mode, direction } = useThemeSettings();

  const theme = useMemo<Theme>(() => {
    return createTheme(createThemeOptions(mode, direction));
  }, [mode, direction]);

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
};
